var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"job-status-badge px-3 py-2",attrs:{"pill":"","variant":_vm.variant}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }